import clsx from 'clsx'
import {isEmpty} from 'lodash'
import {connect, useSelector} from 'react-redux'
import {useEffect, useRef, useState} from 'react'
import {Redirect, useLocation} from 'react-router-dom'
import {ThunkDispatch} from 'redux-thunk'
import {AnyAction} from 'redux'

import {useBMVerifyController} from "./bm-verify-controller";
import {
    BankImagesGridProps,
    BankVerificationPageProps,
    BankVerificationProps,
    BankVerificationPropsToDispatch
} from "./BankVerificationPageProps";
import {getBanks} from "../../store/middleware/prepare.application";
import {AppState} from "../../store";
import {APP_END_LOADING, APP_LOADING} from "../../store/actions/application-actions";
import {BankProps} from '../../components/bank-select/bank-select.props';
import {invokeLoadingWithText} from '../../common/invokeLoading'
import useTextContents from '../../hooks/useTextContents'
import analyticsService from '../../service/analytics.service'
import { SessionStorage } from '../../common/cookie-storage'
import { IAnalyticsEventsTypesNamesResponse } from '../../models/AnaliticsEventModels'
import WaitingScreen from '../WaitingScreens/WaitingScreenPage'
import { STORAGEKEYS } from '../../common/keys'
import {AppLinks} from '../../environment/app-links'
import {KontomatikService} from '../../service/kontomatik-service'
import {detectKontomatikIntegrationMode, KONTOMATIK_INTEGRATION_MODE} from './kontomatik-integration-mode'
import KontomatikSignInRedirectionPanel, {KONTOMATIK_REDIRECTION_PANEL_MODE} from './KontomatikSignInRedirectionPanel'
import { KontomatikSignInRedirectionStatus } from '../../models/request.url.dto'

import PageScreen from "../../components/organisms/Page/PageScreen";
import Paragraph from "../../components/atoms/Paragraph/Paragraph";
import LoanOfferSummaryPanel from '../../components/organisms/LoanOfferSummaryPanel/LoanOfferSummaryPanel'
import BIKHiddenInputs from '../../components/molecules/BIKHiddenInputs/BIKHiddenInputs'
import { WorkflowTypes } from '../../common/workflow'
import {APP_INIT_TYPES} from "../../hooks/HooksProps";

import "./BankVerificationPage.scss";


const htmlKontomatikDivId = 'kontomatikSigninWidgetDivId';
const KONTOMATIK_REDIRECTION_STATUS_MAX_ATTEMPTS = 5;
const KONTOMATIK_REDIRECTION_STATUS_DELAY_MS = 1200;

const BankImagesGrid = (props: BankImagesGridProps) => {
  const textContent = useTextContents()
  let gridStartColumn = 0, gridStartRow = 1;
  const banksHasError = (props.hasBankError && props.isSended)
  let anotherBank: BankProps | undefined = undefined

  if (props.banksList.length === 0) { //TODO Dodać inną obsługę błędów (na podstawie controller.hasBankError)
    console.log("Błąd pobierania listy banków")
  }

  return (
    <>
      <div id="bank-verification-bank-images-container">
        <div id='bank-verification-bank-images-list' className='bank-verification-bank-images-list-safari-only'>
          {
            props.banksList
            .sort((bankA, BankB) => parseInt(bankA.id) - parseInt(BankB.id))
            .map(bank => {
              const numberOfRows = 3; //!!! Zmieniając liczbę wierszy należy pamiętać o poprawie wysokości kontenera w pliku safari.css !!!
              const numberOfColumns = Math.ceil(props.banksList.length / numberOfRows);
              // Wyrażenie pozwalające przypisać do zmiennej anotherBank pierwszy bank którego url będzie = null (bank testowy - "Inny bank")
              anotherBank = (anotherBank === undefined && !bank.imgUrl) ? bank : anotherBank

              if(gridStartColumn++ >= numberOfColumns){
                gridStartColumn = 1;
                gridStartRow = gridStartRow + 1
              }

              return (
                <div
                id={bank.id}
                  key={bank.id}
                  className={clsx('bank-image', bank.isSelected && 'bank-image-selected')}
                  style={{gridRowStart: gridStartRow, gridColumnStart: gridStartColumn}}
                  onClick={(e) => {
                    if(bank.id === anotherBank?.id){
                      props.setIsAnotherBankDialogOpen(true)
                    }
                    else {
                      bank.handleChange && bank.handleChange(e)
                    }
                  }}
                  >
                   {bank.imgUrl ? <img src={bank.imgUrl} alt={bank.bankName} />  : 'Inny Bank' }
                   <div className={clsx('bank-image-opacity', bank.isSelected && 'bank-image-opacity-selected')}/>
                </div>
              )
            })
          }
        </div>
        { banksHasError && <p className='bank-error-message'>{textContent("bmVerifyPage.errorMessages.bankErrorMessage")}</p> }
      </div>
    </>
  )
}



const KontomatikNotWorkingContent = (props: { ANALYTICS_EVENT_TYPES_NAMES: IAnalyticsEventsTypesNamesResponse | undefined }) => {
  const isKontomatikNotWorkingEventSentRef = useRef<boolean>(false)
  const { ANALYTICS_EVENT_TYPES_NAMES } = props


  useEffect(() => {
    if(isKontomatikNotWorkingEventSentRef.current === false){
        (async() => {
          await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.KontomatikScriptNotLoaded)
          isKontomatikNotWorkingEventSentRef.current = true
        })()
    }
  }, [])


  return (
    <div className='bank-verification-kontomatik-error'>
       Błąd ładowania usługi z https://signin.kontomatik.com
    </div>
  )
}

/**
 * Strona która wyświetlana jest, gdy nie możemy wyświetlić widgetu Kontomatika z powodu braku danych z Backendu.
 * Dawniej była wyświetlana strona z wyborem  banku z BlueMedia - aktualnie to placeholder za nią
*/
const BlueMediaContentPlaceholder = (props: { ANALYTICS_EVENT_TYPES_NAMES: IAnalyticsEventsTypesNamesResponse | undefined }) => {
  const isKontomatikWidgetDataMissingFromSessionStorageEventSentRef = useRef<boolean>(false)
  const { ANALYTICS_EVENT_TYPES_NAMES } = props

  useEffect(() => {
    if(isKontomatikWidgetDataMissingFromSessionStorageEventSentRef.current === false){
        (async() => {
          await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.KontomatikWidgetDataMissingFromSessionStorage)
          isKontomatikWidgetDataMissingFromSessionStorageEventSentRef.current = true
        })()
    }
  }, [])

  return <WaitingScreen />
}



const BankVerificationPage = (props: BankVerificationPageProps) => {
  const location = useLocation()
  const textContent = useTextContents()
  const sessionStorage = new SessionStorage()
  const kontomatikService = new KontomatikService()
  const ANALYTICS_EVENT_TYPES_NAMES = useSelector((state: AppState) => state.lenConfigState.analyticsEventTypesNames)
  const APP_ID = useSelector((state: AppState) => state.applicationState.appId)

  const refKontomatikBankCallback = useRef(() => { });
  const refKontomatikSuccessCallback = useRef((target: string, sessionId: string, sessionIdSignature: string) => {   });
  const HAS_KONTOMATIK_CLIENT = !isEmpty(props.kontomatikWidgetClient)
  const HAS_KONTOMATIK_OWNER_EXTERNAL_ID = !isEmpty(props.kontomatikWidgetOwnerExternalId)
  const CAN_SHOW_KONTOMATIK_WIDGET = HAS_KONTOMATIK_CLIENT && HAS_KONTOMATIK_OWNER_EXTERNAL_ID
  const [INTEGRATION_MODE] = useState<KONTOMATIK_INTEGRATION_MODE>(detectKontomatikIntegrationMode())
  const [IS_KONTOMATIK_WORKING, setIsKontomatikWorking] = useState<boolean>(!!window.embedKontomatik)
  const [IS_REDIRECTION_STARTING, setIsRedirectionStarting] = useState<boolean>(false)
  const [REDIRECTION_PANEL_MODE, setRedirectionPanelMode] = useState<KONTOMATIK_REDIRECTION_PANEL_MODE>(
      location.pathname === AppLinks.kontomatikSignInRedirectionReturnError
          ? KONTOMATIK_REDIRECTION_PANEL_MODE.RETURN_ERROR
          : KONTOMATIK_REDIRECTION_PANEL_MODE.DEFAULT
  )

  const IS_EMBEDDED_WIDGET_MODE = INTEGRATION_MODE === KONTOMATIK_INTEGRATION_MODE.EMBEDDED_WIDGET
    // Hard fallback: if widget script is unavailable, force redirection mode.
    const SHOULD_USE_SIGNIN_REDIRECTION = !IS_EMBEDDED_WIDGET_MODE || !IS_KONTOMATIK_WORKING
  const IS_KONTOMATIK_REDIRECTION_RETURN_ERROR_ROUTE = location.pathname === AppLinks.kontomatikSignInRedirectionReturnError

  const getKontomatikRedirectionIdFromQuery = (queryParams: URLSearchParams): string | null => {
    return queryParams.get('redirectionId') ?? queryParams.get('returnId')
  }


  const onSend = (hasConsentError: boolean, hasBankError: boolean)=> {
    if (!hasBankError && !hasConsentError) {
      props.invokeLoadingWithText(textContent('loaders.bankVerification'))
    }
  }

  const controller = useBMVerifyController(props, { onSend : onSend })

    useEffect(() => {
        refKontomatikSuccessCallback.current = (target: string, sessionId: string, sessionIdSignature: string) => {
            controller.sendKontomatikSession(target, sessionId, sessionIdSignature)
        }
    }, [refKontomatikBankCallback, refKontomatikSuccessCallback,  controller])


    const startSignInRedirection = async () => {
        if (IS_REDIRECTION_STARTING || !HAS_KONTOMATIK_OWNER_EXTERNAL_ID) {
            return
        }
        try {
            setRedirectionPanelMode(KONTOMATIK_REDIRECTION_PANEL_MODE.DEFAULT)
            setIsRedirectionStarting(true)
            props.invokeLoadingWithText(textContent('loaders.bankVerification'))

            const currentSearchParams = new URLSearchParams(location.search)
            const appIdFromUrl = currentSearchParams.get("appId")
            const comebackAppId = !isEmpty(APP_ID) ? APP_ID : appIdFromUrl
            const comebackQuery = new URLSearchParams({ source: APP_INIT_TYPES.KONTOMATIK })
            if (!isEmpty(comebackAppId)) {
                comebackQuery.set("appId", comebackAppId as string)
            }

            const redirectUri = `${window.location.origin}${AppLinks.return}?${comebackQuery.toString()}`
            const dto = {
                ownerExternalId: props.kontomatikWidgetOwnerExternalId,
                redirectUri,
            };
            analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.KontomatikShoudUseSignInRedirected,
                JSON.stringify({
                    ownerExternalId: props.kontomatikWidgetOwnerExternalId
                }, undefined, 3))

            const redirectionResponse = await kontomatikService.startSignInRedirection(dto);
            analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.KontomatikSignInRedirected,
                JSON.stringify({
                    ownerExternalId: props.kontomatikWidgetOwnerExternalId,
                    redirectionId: redirectionResponse.redirectionId
                }, undefined, 3))
            window.location.assign(redirectionResponse.url)
        } catch (e) {
            props.endLoading()
            setIsRedirectionStarting(false)
            window.location.assign(AppLinks.kontomatikSignInRedirectionReturnError)
        }
    }

  useEffect(() => {
    refKontomatikSuccessCallback.current = (target: string, sessionId: string, sessionIdSignature: string) => {
      controller.sendKontomatikSession(target, sessionId, sessionIdSignature)
    }
  }, [refKontomatikBankCallback, refKontomatikSuccessCallback,  controller])

    useEffect(() => {
        setRedirectionPanelMode(
            IS_KONTOMATIK_REDIRECTION_RETURN_ERROR_ROUTE
                ? KONTOMATIK_REDIRECTION_PANEL_MODE.RETURN_ERROR
                : KONTOMATIK_REDIRECTION_PANEL_MODE.DEFAULT
        )
    }, [IS_KONTOMATIK_REDIRECTION_RETURN_ERROR_ROUTE])

    useEffect(() => {
        if (!SHOULD_USE_SIGNIN_REDIRECTION) {
            return
        }

        const queryParams = new URLSearchParams(window.location.search)
        const redirectionId = getKontomatikRedirectionIdFromQuery(queryParams)
        const hasKontomatikErrorQuery = Boolean(queryParams.get('error') || queryParams.get('errorCode') || queryParams.get('status') === 'error')

        if (!redirectionId) {
            if (hasKontomatikErrorQuery) {
                (async () => {
                    await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.KontomatikSignInRedirectionFailed)
                })()

                window.location.assign(AppLinks.kontomatikSignInRedirectionReturnError)
            }
            return
        }

        props.invokeLoadingWithText(textContent('loaders.bankVerification'));

        (async () => {
            try {
                for (let attempt = 1; attempt <= KONTOMATIK_REDIRECTION_STATUS_MAX_ATTEMPTS; attempt++) {
                    const redirectionStatus = await kontomatikService.getSignInRedirectionStatus(redirectionId)

                    if (redirectionStatus.status === KontomatikSignInRedirectionStatus.Success && redirectionStatus.sessionId && redirectionStatus.sessionIdSignature) {
                        controller.sendKontomatikSession(
                            redirectionStatus.bankName ?? "",
                            redirectionStatus.sessionId,
                            redirectionStatus.sessionIdSignature
                        )
                        return
                    }

                    if (redirectionStatus.status === KontomatikSignInRedirectionStatus.Error) {
                        analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.KontomatikSignInRedirectionFailed,
                            JSON.stringify({
                                redirectionStatus: redirectionStatus.sessionId,
                                ownerExternalId: props.kontomatikWidgetOwnerExternalId,
                                redirectionId
                            },))
                        window.location.assign(AppLinks.kontomatikSignInRedirectionReturnError)
                        return
                    }

                    if (attempt < KONTOMATIK_REDIRECTION_STATUS_MAX_ATTEMPTS) {
                        await new Promise((resolve) => setTimeout(resolve, KONTOMATIK_REDIRECTION_STATUS_DELAY_MS))
                    }
                }

                props.endLoading()
                window.location.assign(AppLinks.kontomatikSignInRedirectionReturnError)
            } catch (e) {
                props.endLoading()
                window.location.assign(AppLinks.kontomatikSignInRedirectionReturnError)
            }
        })()
    }, [SHOULD_USE_SIGNIN_REDIRECTION, controller, props, textContent])


  useEffect(() => {
    if (IS_EMBEDDED_WIDGET_MODE && HAS_KONTOMATIK_CLIENT && IS_KONTOMATIK_WORKING && document.getElementById(htmlKontomatikDivId)) {
      window.embedKontomatik({
        client: props.kontomatikWidgetClient,  // replace it with your assigned client id
        divId: htmlKontomatikDivId,       // must match the div element id
        ownerExternalId: props.kontomatikWidgetOwnerExternalId,
        country: "pl",
        locale: "pl",
        showFavicons: true,

        onConsentsGiven: () => {
          refKontomatikBankCallback.current();
        },
        onSuccess: async(target: string, sessionId: string, sessionIdSignature: string, options: { officialName: string }) => {
          // End-user successfully signed in to the bank
          // Pass target, sessionId and sessionIdSignature to your backend

          await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.KontomatikSuccess, JSON.stringify({
            sessionId,
            sessionIdSignature,
            bankOfficialName: options.officialName
          }, undefined, 3))

          refKontomatikSuccessCallback.current(target, sessionId, sessionIdSignature);
        },
        onError: async(errorMessage: string, options: { officialName: string, sessionId: string, widgetSessionId: string }) => {
          await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.KontomatikError, JSON.stringify({
            errorMessage,
            bankOfficialName: options.officialName,
            sessionId: options.sessionId,
            widgetSessionId: options.widgetSessionId,
          }, undefined, 3))
        },
        onTargetSelected: async (bankNamesObject: { name: string, officialName: string }) => {
          const bankOfficialName = bankNamesObject.officialName
          sessionStorage.add(STORAGEKEYS.CURRENT_SELECTED_BANK_NAME,bankOfficialName)

          await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.KontomatikBankSelected, JSON.stringify({ bankOfficialName }, undefined, 3))
        },
        onSessionCreated: async (kontomatikSession: { sessionId: string }) => { //Zainicjalizowanie sesji w Kontomatik
          const bankOfficialName = sessionStorage.get(STORAGEKEYS.CURRENT_SELECTED_BANK_NAME)
          const bankSessionCreatedEventData = {...kontomatikSession, bankOfficialName}

          await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.KontomatikSessionCreated, JSON.stringify(bankSessionCreatedEventData, undefined, 3))
        },
        onRedirect: async() => {
          const bankOfficialName = sessionStorage.get(STORAGEKEYS.CURRENT_SELECTED_BANK_NAME)
          await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.KontomatikExternalTabBankRedirect, JSON.stringify({ bankOfficialName }, undefined, 3))
        }
      });

      return () => {
        //cleanup
        window.removeKontomatik();
      }
    }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [IS_EMBEDDED_WIDGET_MODE, IS_KONTOMATIK_WORKING, props.kontomatikWidgetClient, props.kontomatikWidgetOwnerExternalId])

    if (!SHOULD_USE_SIGNIN_REDIRECTION && IS_KONTOMATIK_REDIRECTION_RETURN_ERROR_ROUTE) {
        return <Redirect to={AppLinks.bmverify}/>
    }

  if(SHOULD_USE_SIGNIN_REDIRECTION) {
    return (
      <KontomatikSignInRedirectionPanel
                isRedirectStarting={IS_REDIRECTION_STARTING}
                onStartRedirection={startSignInRedirection}
                mode={REDIRECTION_PANEL_MODE}
            />
    )
  }

    //  2: brak danych z backendu (placeholder) albo widget osadzony na stronie
    return !CAN_SHOW_KONTOMATIK_WIDGET ? (
        <BlueMediaContentPlaceholder ANALYTICS_EVENT_TYPES_NAMES={ANALYTICS_EVENT_TYPES_NAMES}/>
    ) : (
  <PageScreen
      title={{title: textContent('bmVerifyPage.heading'), line: true}}
      panel={<LoanOfferSummaryPanel readOnly loanVariant='predefined'/>}
  >
      <div className='bank-verification-page-wrapper'>
        <BIKHiddenInputs showInputs={WorkflowTypes.isFromExternalIntegrator()} />
        <div className='bank-verification-page-description'>
          <Paragraph  html={textContent('bmVerifyPage.mainContentTextUp')}/>
          <Paragraph  html={textContent('bmVerifyPage.mainContentTextDown')}/>
        </div>
        {
          IS_KONTOMATIK_WORKING ?
            <div className='bank-verification-kontomatik' id={htmlKontomatikDivId} /> :
            <KontomatikNotWorkingContent ANALYTICS_EVENT_TYPES_NAMES={ANALYTICS_EVENT_TYPES_NAMES} />
        }
      </div>
  </PageScreen>
  );
};

const mapStateToProps = (store: AppState): BankVerificationProps => {
  return {
    banks: store.applicationState.banks,
    offert: store.applicationState.offert,
    billingCompany: store.applicationState.billingCompany,
    amountToPay: store.applicationState.amountToPay,
    kontomatikWidgetClient: store.applicationState.kontomatikWidgetClient,
    kontomatikWidgetOwnerExternalId: store.applicationState.kontomatikWidgetOwnerExternalId,
  };
};

const mapDispatch = (dispatch: ThunkDispatch<any, any, AnyAction>): BankVerificationPropsToDispatch => {
  return {
    getBanks: () => dispatch(getBanks()),
    invokeLoadingWithText: (loadingText: string) => dispatch(invokeLoadingWithText(loadingText)),
    invokeLoading: () => dispatch({ type: APP_LOADING }),
    endLoading: () => dispatch({ type: APP_END_LOADING }),
  };
};

export default connect(mapStateToProps, mapDispatch)(BankVerificationPage);
